/* corex-textil-editor-size-ui.js · Tamaño de los elementos sobre la prenda (personalizador de camisetas):
   - Etiqueta con el ancho real de la selección en la talla de referencia ("28 cm ✎" y su alto al lado), sobre una
     cota de borde a borde de la selección; al tocarla se escribe el ancho y la selección se escala sin deformarse.
   - Tope al máximo de la talla de referencia (el menor entre la prenda y el film; CorexTextilModel.sizeLimit) al
     escalar por las esquinas, al pellizcar, al girar y al escribir el ancho: se queda en el máximo sin deformarse y
     avisa «Tamaño máximo para la talla X».
   - Al cambiar el tamaño, delante/detrás mantiene el borde superior (crece hacia abajo y a los lados) y las mangas el
     inferior (crece hacia arriba).
   Reglas puras en corex-textil-editor-sizing.js. attach(ed) recibe del editor: root, canvas, metrics(), tab(),
   isFlat(), size(), limit(top), useful() (zona útil de la vista, con halfAt en las que se estrechan arriba), itemsOf(), selectedIds(), setItems(items), lockReason(), dragging(), posMsg(text),
   announce(text), refresh(). */
(function () {
  'use strict';

  var G = window.CorexTextilGeo, M = window.CorexTextilModel, IO = window.CorexTextilIO;
  var GR = window.CorexTextilGroups, SZ = window.CorexTextilSizing, OV = window.CorexTextilOverlay;
  var TOAST_MS = 1800;
  var WIDTH_MIN = 0.5;
  var WIDTH_MAX = 80;
  var LABEL_GAP_PX = 10;
  var EDGE_PX = 4;

  function attach(ed) {
    var q = function (s) { return ed.root.querySelector(s); };
    var wrap = q('[data-cte-wl]'), line = q('[data-cte-wl-line]'), btn = q('[data-cte-wl-btn]'), hOut = q('[data-cte-wl-h]');
    var edit = q('[data-cte-wl-edit]'), input = q('[data-cte-wl-input]'), toastEl = q('[data-cte-toast]');
    var toastTimer = 0;
    var free = M.printSize(M.FREE_AREA);

    function toast(text) {
      toastEl.textContent = text;
      toastEl.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.hidden = true; }, TOAST_MS);
    }
    function anchor() { return ed.isFlat() ? 'top' : 'bottom'; }
    function maxMsg() { return 'Tamaño máximo para la talla ' + ed.size(); }
    /* ¿Caben en el máximo de la talla de referencia las impresiones de la zona que contienen alguno de ids? */
    function designOk(items, ids) {
      if (!ed.isFlat()) { var b = G.designBounds(items); return !b || M.fitsLimit(b.w, b.h, ed.limit(0)); }
      return GR.derivePrints({ viewId: ed.tab(), items: items, corners: G.layerCorners, size: M.FREE_AREA, areaH: free.h }).every(function (p) {
        if (!p.itemIds.some(function (id) { return ids.indexOf(id) !== -1; })) return true;
        var x = p.box, z = ed.useful ? ed.useful() : null;
        /* prendas que se estrechan arriba (sisas, raglán): el borde superior, el más estrecho, también debe caber */
        if (z && z.halfAt && Math.max(Math.abs(x.x0), Math.abs(x.x1)) > z.halfAt(x.y0) + 0.01) return false;
        return M.fitsLimit(x.x1 - x.x0, x.y1 - x.y0, ed.limit(x.y0));
      });
    }
    function limitedScale(items, ids, wanted) {
      return SZ.limitFactor(function (f) { return designOk(SZ.scaleLayers(items, ids, f, G.layerCorners, anchor()), ids); }, wanted);
    }
    /* Ancla del escalado de una capa (cm de la zona), para medir el gesto desde ella. */
    function anchorOf(l) { var b = SZ.boxOfIds([l], [l.id], G.layerCorners); return b ? SZ.anchorPoint(b, anchor()) : { x: l.x, y: l.y }; }
    /* Esquinas y pellizco: la capa como estaba al empezar el gesto (base) escalada por factor, con ancla y tope.
       Devuelve el patch (tamaño y posición). */
    function scaleFrom(base, factor, min, max) {
      var cur = base.type === 'text' ? base.size : base.w, want = G.clamp(cur * factor, min, max) / cur;
      var items = ed.itemsOf().map(function (x) { return x.id === base.id ? base : x; });
      var r = limitedScale(items, [base.id], want);
      if (r.limited) toast(maxMsg());
      var l = SZ.scaleLayers(items, [base.id], r.factor, G.layerCorners, anchor()).filter(function (x) { return x.id === base.id; })[0];
      var v = l.type === 'text' ? l.size : l.w;
      v = r.limited ? Math.floor(v * 100) / 100 : IO.round(v, 2);
      return Object.assign(l.type === 'text' ? { size: v } : { w: v }, { x: IO.round(l.x, 3), y: IO.round(l.y, 3) });
    }
    /* Giro: si la caja girada no cabe en el máximo, la capa se queda como estaba. */
    function rotatePatch(l, deg) {
      /* l puede traer ya el tamaño nuevo (pellizco: escalar y girar a la vez) */
      var items = ed.itemsOf().map(function (x) { return x.id === l.id ? Object.assign({}, x, l, { rotation: deg }) : x; });
      if (designOk(items, [l.id])) return { rotation: deg };
      toast(maxMsg());
      return {};
    }
    function selBox() { return SZ.boxOfIds(ed.itemsOf(), ed.selectedIds(), G.layerCorners); }
    /* Escala la selección para que mida `width` cm de ancho (sin pasar del máximo). */
    function setWidth(width) {
      var ids = ed.selectedIds(), b = selBox();
      if (!b || !(b.w > 0)) return;
      var r = limitedScale(ed.itemsOf(), ids, width / b.w);
      var items = SZ.scaleLayers(ed.itemsOf(), ids, r.factor, G.layerCorners, anchor()).map(function (l) {
        if (ids.indexOf(l.id) === -1) return l;
        var rd = function (v) { return r.limited ? Math.floor(v * 100) / 100 : IO.round(v, 2); };
        return Object.assign({}, l, l.type === 'text' ? { size: rd(l.size) } : { w: rd(l.w) }, { x: IO.round(l.x, 3), y: IO.round(l.y, 3) });
      });
      ed.setItems(items);
      var nb = selBox();
      if (r.limited) {
        toast(maxMsg());
        ed.posMsg(maxMsg() + ': se ha ajustado a ' + IO.fmt(nb.w) + ' × ' + IO.fmt(nb.h) + ' cm.');
      }
      ed.announce('Ancho ' + IO.fmt(nb.w) + ' cm, alto ' + IO.fmt(nb.h) + ' cm.');
    }

    /* Imagen recién añadida: si no cabe en el máximo de la talla, se reduce hasta el máximo (sin deformar) y se avisa. */
    function fitSelection() {
      var ids = ed.selectedIds(), items = ed.itemsOf(), b = selBox();
      if (!b || designOk(items, ids)) return false;
      var f = SZ.shrinkFactor(function (x) { return designOk(SZ.scaleLayers(items, ids, x, G.layerCorners, anchor()), ids); });
      if (!(f > 0)) return false;
      ed.setItems(SZ.scaleLayers(items, ids, f, G.layerCorners, anchor()).map(function (l) {
        if (ids.indexOf(l.id) === -1) return l;
        return Object.assign({}, l, l.type === 'text' ? { size: Math.floor(l.size * 100) / 100 } : { w: Math.floor(l.w * 100) / 100 }, { x: IO.round(l.x, 3), y: IO.round(l.y, 3) });
      }));
      var nb = selBox();
      toast(maxMsg());
      ed.posMsg('La imagen no cabía en la talla ' + ed.size() + ': se ha reducido a ' + IO.fmt(nb.w) + ' × ' + IO.fmt(nb.h) + ' cm.');
      return true;
    }

    function open() {
      var b = selBox();
      if (!b) return;
      edit.hidden = false;
      btn.hidden = true;
      input.value = IO.fmt(b.w);
      ed.refresh();
      input.focus();
      input.select();
    }
    function close() { edit.hidden = true; btn.hidden = false; ed.refresh(); }
    function commit() {
      var parsed = IO.parseCm(input.value, WIDTH_MIN, WIDTH_MAX);
      if (parsed.empty || parsed.invalid) {
        ed.posMsg('Escribe un ancho entre ' + IO.fmt(WIDTH_MIN) + ' y ' + WIDTH_MAX + ' cm.');
        input.setAttribute('aria-invalid', 'true');
        return false;
      }
      input.setAttribute('aria-invalid', 'false');
      ed.posMsg('');
      edit.hidden = true;
      btn.hidden = false;
      setWidth(parsed.value);
      return true;
    }
    btn.addEventListener('click', open);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); if (commit()) btn.focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus(); }
    });
    input.addEventListener('blur', function () { if (!edit.hidden && !commit()) close(); });

    /* Coloca la etiqueta centrada bajo la selección y, a su altura, la cota de ancho de borde a borde de la selección
       (px del escenario). Devuelve la caja de la etiqueta para que la barra la esquive. */
    function place(stage) {
      var m = ed.metrics(), b = selBox();
      wrap.hidden = !m || !b || !!ed.lockReason() || ed.dragging();
      line.hidden = wrap.hidden;
      if (wrap.hidden) return null;
      if (edit.hidden) {
        btn.textContent = IO.fmt(b.w) + ' cm ✎';
        btn.setAttribute('aria-label', 'Ancho del diseño: ' + IO.fmt(b.w) + ' cm (alto ' + IO.fmt(b.h) + ' cm). Pulsa para cambiarlo.');
      }
      hOut.textContent = 'alto ' + IO.fmt(b.h) + ' cm';
      var it = m.items[0], pts = [[b.x0, b.y1], [b.x1, b.y1]].map(function (p) {
        var f = m.frame.fwd(p[0] + it.area.cu, p[1] + it.cv);
        return OV.toCss(m, ed.canvas, f.x, f.y);
      });
      var w = wrap.offsetWidth, h = wrap.offsetHeight, sw = stage.clientWidth, sh = stage.clientHeight;
      var x = Math.min(Math.max((pts[0].x + pts[1].x) / 2 - w / 2, EDGE_PX), Math.max(EDGE_PX, sw - w - EDGE_PX));
      var y = Math.min(Math.max(pts[0].y, pts[1].y) + LABEL_GAP_PX, sh - h - EDGE_PX);
      wrap.style.left = Math.round(x) + 'px';
      wrap.style.top = Math.round(y) + 'px';
      var lx0 = Math.min(pts[0].x, pts[1].x), lx1 = Math.max(pts[0].x, pts[1].x);
      line.style.left = lx0 + 'px';
      line.style.width = (lx1 - lx0) + 'px';
      line.style.top = Math.round(y + h / 2) + 'px';
      return { x0: x - 4, x1: x + w + 4, y0: y - 4, y1: y + h + 4 };
    }

    return { place: place, scaleFrom: scaleFrom, anchorOf: anchorOf, rotatePatch: rotatePatch, toast: toast, setWidth: setWidth, fitSelection: fitSelection };
  }

  window.CorexTextilSizeUI = { attach: attach };
})();
